export default __webpack_public_path__ + "static/media/image-upload.b59926a6.png";